type DurabilityImageProps = {
    score?: number;
};

export function DurabilityImage({ score }: Readonly<DurabilityImageProps>) {
    if (score === undefined || score < 0 || score > 10) {
        return null;
    }

    return (
        <img
            src={`https://www.bouyguestelecom.fr/assets/media/original/image/CMS/ecommerce/durability/IDD_${score * 10}.svg`}
            alt={`Indice de durabilité : ${score} sur 10`}
            width={85}
        />
    );
}
